import { HttpStatusCode } from "../../../../common/infra/http-status/http-status";
import { BackedApi } from "../../../../config/urls/Api";
import { ResponseCreateSessionDto } from "./dto/response-create-session.dto";
import { ResponseGetSessionDto } from "./dto/response-get-sessions.dto";
import { ResponseListAllSessionsDto } from "./dto/response-list-all-sessions.dto";
import { ResponseListSessionsDto } from "./dto/response-list-sessions.dto";

export class SessionRepository {
    static async createSession(workoutId: string, name: string, captureReactionTime: boolean): Promise<ResponseCreateSessionDto> {
        const response = await this.sendRequest(
            BackedApi.CreateSession.url,
            BackedApi.CreateSession.method,
            { workoutId, name, capture_reaction_time: captureReactionTime }
        )
        const data = await response.json();
        const status = response.status;
        return {
            data,
            error: status !== HttpStatusCode.CREATED,
            status,
            code: data?.code,
            drillId: data?.drillId,
            executionsUsed: data?.executionsUsed,
            executionsLimit: data?.executionsLimit,
        };
    }

    static async listSessions(workoutId: string): Promise<ResponseListSessionsDto> {
        const { url, method } = BackedApi.ListSessions(workoutId);
        const response = await this.sendRequest(url, method);
        const data = await response.json();
        const status = response.status;
        return { data: Array.isArray(data) ? data : data?.data ?? [], error: status !== 200, status };
    }

    static async listAllSessions(): Promise<ResponseListAllSessionsDto> {
        const { url, method } = BackedApi.ListAllSessions;
        const response = await this.sendRequest(url, method);
        const data = await response.json();
        const status = response.status;
        const rows = Array.isArray(data) ? data : data?.data ?? [];
        return { data: rows, error: status !== 200, status };
    }

    static async getSession(sessionId: string): Promise<ResponseGetSessionDto> {
        const { url, method } = BackedApi.GetSession(sessionId);
        const response = await this.sendRequest(url, method);
        const data = await response.json();
        const status = response.status;
        return { data: data?.data ?? data, error: status !== HttpStatusCode.OK, status };
    }

    private static async sendRequest(url: string, method: string, body?: any) {
        const response = await fetch(url, {
            method,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            ...(body && { body: JSON.stringify(body) }),
        })
        return response;
    }
}